import DataTable_s from "components/table/data-table-styles"
import styled from "styled-components"
import { Colors } from 'styles/app-styles'

export const Chart_s = styled.div`

`

export const ChartTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  padding-bottom: 0;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .area-measure-input {
    width: 185px;
  }

  .p-paginator {
    bottom: 0;
  }
`

export const Breadcrumb_s = styled.span`
  align-items: center;
  display: flex;
  height: 100%;
  margin-right: 8px;
`

export const ChartChildTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  height: calc(100vh - 180px);
  margin-top: -5px;
  padding-bottom: 0;

  thead.p-datatable-thead {
    padding: 10px 0;
  }

  th.p-filter-column > input {
    width: 100%;
  }

  .p-datatable-scrollable-view {
    thead.p-datatable-thead {
      background: ${Colors.white};
      position: fixed;
      z-index: 1;
    }
  }

  .p-datatable-scrollable-body {
    padding-bottom: 100px;
    padding-top: 57px;
  }

  div.p-datatable-scrollable-view.p-datatable-frozen-view thead.p-datatable-thead {
    background: ${Colors.white};
    height: 92px;
    padding-top: 43px;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    margin: 40px 0 30px 0;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  tbody.p-datatable-tbody > tr > td {
    padding-left: 5px;
  }

  .p-paginator {
    bottom: 0;
  }
`

export const CashFlowMapTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin-top: -5px;
  padding-bottom: 0;

  thead.p-datatable-thead {
    padding: 10px 0;
  }

  th.p-filter-column > input {
    width: 100%;
  }

  th.p-filter-column:first-child {
    width: 300px;
  }

  .p-datatable-scrollable-view {
    thead.p-datatable-thead {
      background: ${Colors.white};
      position: fixed;
      z-index: 1;
    }
  }

  .p-datatable-scrollable-body {
    padding-top: 47px;
  }

  .p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    margin: 40px 0 30px 0;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  tbody.p-datatable-tbody > tr > td {
    padding-left: 5px;
  }

  .p-paginator {
    bottom: 0;
  }

  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }
`
